import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { loadSessionsDailySummaryAsync, selectSessionsDailySummary } from '../dashboardSlice';
import { StatCard } from './StatCard';

// Mesma janela do SessionsActivityChart (aba Atividade) — os dois leem do
// mesmo slice (sessionsDailySummary); usar o mesmo valor evita que abrir a
// aba dispare um segundo carregamento redundante com janela diferente.
const HISTORY_DAYS = 30;

const formatDuration = (totalSeconds) => {
    const seconds = Math.round(totalSeconds);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    if (h > 0) return `${h}h ${String(m).padStart(2, '0')}min`;
    if (m > 0) return `${m}min ${String(s).padStart(2, '0')}s`;
    return `${s}s`;
};

export const TodaySessionsCard = () => {
    const dispatch = useDispatch();
    const routerHistory = useHistory();
    const { data, status } = useSelector(selectSessionsDailySummary);

    useEffect(() => {
        dispatch(loadSessionsDailySummaryAsync(HISTORY_DAYS));
    }, [dispatch]);

    const { today, avgDurationSeconds, history } = useMemo(() => {
        if (!Array.isArray(data) || !data.length) return { today: 0, avgDurationSeconds: 0, history: [] };
        const last = data[data.length - 1];
        return {
            today: last?.userCount ?? 0,
            avgDurationSeconds: last?.avgDurationSeconds ?? 0,
            history: data.map(d => d.userCount),
        };
    }, [data]);

    return (
        <StatCard
            label="Usuários com sessão"
            icon="pi-clock"
            color="var(--cyan-500)"
            value={today}
            loading={status === 'idle'}
            secondary={status === 'idle' ? 'Hoje' : `Hoje · média ${formatDuration(avgDurationSeconds)}`}
            history={history}
            onClick={() => routerHistory.push('/users', { preset: 'sessionToday', presetLabel: 'Usuários com sessão hoje' })}
        />
    );
};
